module.exports = __webpack_public_path__ + "img/145.7.5a66c1b3.png";